import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";
import { z } from "zod";
export const BorderWidthUnit = z.enum(["Pixels"]);
export const BorderWidthValue = z.object({
    unit: DimensionUnit,
    measure: z.number(),
});
export const BorderWidthTokenData = tokenAliasOrValue(BorderWidthValue);
